module.exports = __webpack_public_path__ + "static/ss4.546ef212.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss4.png
// module id = 1200
// module chunks = 81679748166845